import React from 'react'
import { node } from 'prop-types'
import { Typography } from '@creditas-ui/react'
import { getCurrentPeriod } from './dailyPeriod'
import i18n from '~/i18n/i18n'

const propTypes = {
  children: node.isRequired,
}

const GreetingsContent = ({ children }) => {
  return (
    <Typography
      variant={{ _: 'bodyXlRegular', '4xl': 'headingLgRegular' }}
      color="neutral.90"
    >
      {children}
    </Typography>
  )
}

const greetingsMessages = {
  MORNING: (
    <GreetingsContent>
      {i18n.t('pages:password.identify.greetings.good_morning')}
    </GreetingsContent>
  ),
  AFTERNOON: (
    <GreetingsContent>
      {i18n.t('pages:password.identify.greetings.good_afternoon')}
    </GreetingsContent>
  ),
  NIGHT: (
    <GreetingsContent>
      {i18n.t('pages:password.identify.greetings.good_evening')}
    </GreetingsContent>
  ),
}

const Greetings = () => greetingsMessages[getCurrentPeriod()]

GreetingsContent.propTypes = propTypes

export { Greetings }
